import { render, staticRenderFns } from "./camochairdetail.vue?vue&type=template&id=c97447b6&scoped=true&"
import script from "./camochairdetail.vue?vue&type=script&lang=js&"
export * from "./camochairdetail.vue?vue&type=script&lang=js&"
import style0 from "./camochairdetail.vue?vue&type=style&index=0&id=c97447b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97447b6",
  null
  
)

export default component.exports